import React from 'react'

const Required = () => {
  return (
    <span className="text-rose-500 text-normal-text leading-none">*</span>
  )
}

export default Required